import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PanelViewsList } from "./types";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type PanelState = {
  currentView: PanelViewsList;
  mainViewScrollPosition: number;
};

const initialPanelState: PanelState = {
  currentView: PanelViewsList.main,
  mainViewScrollPosition: 0,
};

const panelSlice = createSlice({
  name: "panel",
  initialState: initialPanelState,
  reducers: {
    setCurrentViewAction: (state, action: PayloadAction<PanelViewsList>) => {
      state.currentView = action.payload;
    },
    setMainViewScrollPosition: (state, action: PayloadAction<number>) => {
      state.mainViewScrollPosition = action.payload;
    },
  },
});

const panelBaseSelector = createBaseSelector(panelSlice);

registerSlice([panelSlice]);

export const panelStore = {
  actions: panelSlice.actions,
  selectors: {
    currentView: createSelector(panelBaseSelector, (s) => s.currentView),
    mainViewScrollPosition: createSelector(panelBaseSelector, (s) => s.mainViewScrollPosition),
  },
};
